/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Analysis_Note_LabelInputs */

const en_doc_analysis_note_label = /** @type {(inputs: Doc_Analysis_Note_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case analysis`)
};

const pt_br2_doc_analysis_note_label = /** @type {(inputs: Doc_Analysis_Note_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise do caso`)
};

/**
* | output |
* | --- |
* | "Case analysis" |
*
* @param {Doc_Analysis_Note_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_analysis_note_label = /** @type {((inputs?: Doc_Analysis_Note_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Analysis_Note_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_analysis_note_label(inputs)
	return pt_br2_doc_analysis_note_label(inputs)
});